<template>
  <div>
    <div class="card-body">
      <div class="loading-overlay" v-if="loading"></div>
      <table class="table table-striped table-bordered table-centered">
        <thead>
          <tr>
            <th>Claim Reference</th>
            <th>Type</th>
            <th>Date</th>
            <th>Location</th>
            <th>Vehicle</th>
            <th>Hire Period</th>
            <th>Assigned To Run?</th>
            <th v-if="hasPermission('jobs.read')">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="!!jobs && jobs.length">
          <tr v-bind:key="index" v-for="(job, index) in jobs">
            <td>
              <jobable-claim-reference :job="job"></jobable-claim-reference>
            </td>
            <td>
              <job-label :job="job"></job-label>
            </td>
            <td>
              {{ job.date | date }}
            </td>
            <td>
              {{ job.location }}
            </td>
            <td>
              {{ job.vehicle?.registration }}
            </td>
            <td>
              <job-hire-period :job="job"></job-hire-period>
            </td>
            <td>
              <span
                class="badge"
                :class="{
                  'badge-success': job.item,
                  'badge-danger': !job.item
                }"
                v-if="job.type.name !== 'third_party_movement'"
              >
                {{ job.item ? 'Yes' : 'No' }}
              </span>
              <span v-else>N/A</span>
            </td>
            <td class="text-right" v-if="hasPermission('jobs.read')">
              <router-link
                class="btn btn-primary"
                :to="`/jobs/${job.identifier}`"
              >
                View Job
              </router-link>
            </td>
          </tr>
        </tbody>
        <tbody v-if="!jobs.length">
          <tr>
            <td colspan="8" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import JobLabel from '@/components/Modules/Shared/JobLabel';
import JobHirePeriod from '@/components/Modules/Shared/JobHirePeriod';
import JobableClaimReference from '@/components/Modules/Job/Children/JobableClaimReference';

export default {
  props: {
    incident: {
      type: Number,
      required: true
    }
  },

  components: {
    JobLabel,
    JobHirePeriod,
    JobableClaimReference
  },

  data() {
    return {
      indicator: false,
      jobs: [],
      loading: true
    };
  },

  mounted() {
    window.Ajax.get(
      `/jobs?sort=date&parts=item,type,jobable&filter[incident_id]=${this.incident}`
    )
      .then(response => {
        this.loading = false;
        this.jobs = response.data;
      })
      .catch(err => {});
  },

  methods: {}
};
</script>
